import {
  Box,
  Divider,
  DialogContentText,
  type BoxProps,
  type DividerProps,
  type DialogContentTextProps,
} from "@mui/material";
import { ReactNode } from "react";

interface FormSectionProps {
  title: string;
  children: ReactNode;
  direction?: BoxProps["flexDirection"];
  wrap?: boolean;
  containerProps?: BoxProps;
  fieldContainerProps?: BoxProps;
  dividerProps?: DividerProps;
  titleProps?: DialogContentTextProps;
}

const FormSection = ({
  title,
  direction = "column",
  wrap = false,
  children,
  containerProps,
  fieldContainerProps,
  dividerProps,
  titleProps,
}: FormSectionProps) => {
  return (
    <Box
      marginY={2}
      {...containerProps}
      sx={{
        "&:first-of-type": {
          marginTop: 0,
        },
      }}
    >
      <DialogContentText margin={0} {...titleProps}>
        {title}
      </DialogContentText>
      <Divider
        sx={{
          opacity: ".25",
          borderColor: "black",
          margin: 0,
          marginBottom: 1,
        }}
        variant="fullWidth"
        {...dividerProps}
      />
      <Box
        display="flex"
        gap={2}
        padding={1}
        flexDirection={direction}
        flexWrap={wrap ? "wrap" : "nowrap"}
        {...fieldContainerProps}
      >
        {children}
      </Box>
    </Box>
  );
};
export default FormSection;
